const AboutData = [
    "Hello! I’m Saransh Mehta, a passionate Full Stack Software Engineer who thrives on building impactful software solutions accessible to the entire world. I specialize in designing and implementing scalable, intelligent systems using cutting-edge technologies like React, Node.js, TypeScript, PostgreSQL, AWS, and Azure.",
    "I’m an advocate for open-source contributions and enjoy collaborating with global developers to push the boundaries of innovation and build tools that matter."
]

export default AboutData